export const initialState = {
  snoozeMaintenanceReminder: [],
  recommendedServices: []
}

export default function (state = initialState, action) {
  const { payload, type } = action

  switch (type) {
    case "VEHICLE_UPCOMING_INTERVAL_SNOOZE_SUCCEEDED":
      return {
        ...state,
        snoozeMaintenanceReminder: payload.vehicleId
      }
    case "VEHICLE_UPCOMING_INTERVAL_SNOOZED_DATE_LOAD_SUCCEEDED":
      return {
        ...state,
        snoozedReminderDates: payload.snoozedReminderDates
      }
    case "GET_CARADVISE_RECOMMENDED_SERVICES_SUCCEEDED":
      return {
        ...state,
        recommendedServices: payload.recommendedServices
      }
    case "GET_CARADVISE_RECOMMENDED_SERVICES_FAILED":
      return {
        ...state,
        recommendedServices: []
      }
    default:
      return state
  }
}
